export default "__VITE_ASSET__DhvMhlVi__"